import React, { useState } from 'react';
import { translate } from '../Services/translation';

const RemoveButton = ({ onClick }) => {
  const [popupOpen, setPopupOpen] = useState(false);
  return (
    <>
      <button
        className="checkout-cart__delete"
        onClick={() => setPopupOpen(true)}
        aria-label={translate('general.remove')}
      >
        <svg>
          <use href="/ui/images/sprites/brenderup.svg#delete"></use>
        </svg>
      </button>
      {popupOpen && (
        <>
          <div className="popup" role="dialog" aria-modal="true">
            <div className="popup__inner">
              <button
                className="popup__inner--close"
                onClick={() => setPopupOpen(false)}
                title={translate('general.cancel')}
                onKeyDown={(e) => {
                  if (e.key === 'Escape') {
                    setPopupOpen(false);
                  }
                }}
              >
                <svg>
                  <use href="/ui/images/sprites/brenderup.svg#close"></use>
                </svg>
              </button>

              <div className="cart__popupComment delete-product">
                <h3 className="cart__popupComment--label">
                  {translate('shoppinglist.removefromshoppinglistheader')}
                </h3>
                <p>{translate('shoppinglist.removefromshoppinglist')}</p>
                <button
                  className="button popup__inner--button"
                  onClick={() => {
                    setPopupOpen(false);
                    onClick();
                  }}
                  title={translate('general.ok')}
                  tabIndex={0}
                >
                  {translate('general.ok')}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default RemoveButton;
